const AUTH_STATE_CHANGE = 'authStateChange'
const ORG_SELECTED = 'orgSelected'
const ORG_SWITCHED = 'orgSwitched'
const ORG_SETTINGS_TAB_SWITCHED = 'orgSettingsTabSwitched'
const NO_ORG_SELECTED = 'noOrgSelected'
const PREV_ORG = 'prevOrg'
const NEXT_ORG = 'nextOrg'
const SET_PANEL_COUNT = 'setPanelCount'
const SET_PANEL_PATH = 'setPanelPath'
const LOGIN = 'login'
const LOGOUT = 'logout'
const ATTACHMENT_UPLOADING = 'attachmentUploading'
const ATTACHMENT_UPLOADED = 'attachmentUploaded'
const FOCUS_FIRST_TRANS_LINE = 'focusFirstTransLine'
const FOCUS_TRANS_SUBMIT = 'focusTransSubmit'
const CREDIT_INVOICE = 'creditInvoice'
const WINDOW_SCROLL_START = 'windowScrollStart'
const WINDOW_SCROLL_END = 'windowScrollEnd'

export {
    AUTH_STATE_CHANGE,
    FOCUS_FIRST_TRANS_LINE,
    FOCUS_TRANS_SUBMIT,
    ORG_SELECTED,
    ORG_SWITCHED,
    ORG_SETTINGS_TAB_SWITCHED,
    NO_ORG_SELECTED,
    PREV_ORG,
    NEXT_ORG,
    SET_PANEL_PATH,
    SET_PANEL_COUNT,
    LOGIN,
    LOGOUT,
    ATTACHMENT_UPLOADING,
    ATTACHMENT_UPLOADED,
    CREDIT_INVOICE,
    WINDOW_SCROLL_START,
    WINDOW_SCROLL_END
}